// src/components/Contact.js
import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [activeMap, setActiveMap] = useState(1);

  const contactInfo = [
    {
      icon: "fas fa-envelope",
      title: "Contacto por Email",
      contacts: [
        { email: "info@olpeal.com.ar", name: "General" },
    
      ]
    },
    {
      icon: "fas fa-phone",
      title: "Teléfono",
      content: "+54 9 3544 63-9290",
      subtext: "Disponible de Lunes a Viernes"
    },
    {
      icon: "fas fa-clock",
      title: "Horario de atención",
      content: "Lunes a Viernes: 8:00 - 18:00 hs",
      subtext: "Sábados: 9:00 - 13:00 hs"
    }
  ];

  const locations = [
    {
      id: 1,
      name: "Campo Principal",
      address: "Córdoba, Argentina",
      coordinates: "-31.971929, -65.324648",
      mapUrl: "https://www.google.com/maps?q=-31.971929,-65.324648",
      description: "Nuestro campo principal de cultivo de olivos"
    },
    {
      id: 2,
      name: "Campo Secundario",
      address: "Córdoba, Argentina",
      coordinates: "-31.974484, -65.253835",
      mapUrl: "https://www.google.com/maps?q=-31.974484,-65.253835",
      description: "Campo dedicado a pecanes y almendros"
    }
  ];

  return (
    <section id="contacto" className="contact-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Contacto</h2>
          <p className="section-subtitle">
            Estamos aquí para atender tus consultas sobre nuestros productos de olivos, pecanes y almendros.
          </p>
        </div>

        <div className="contact-grid">
          {/* Columna de información de contacto */}
          <div className="contact-info-column">
            <div className="contact-info-card">
              <h3 className="contact-card-title">
                <i className="fas fa-headset me-2"></i>
                Información de Contacto
              </h3>
              
              {contactInfo.map((info, index) => (
                <div className="contact-info-item" key={index}>
                  <div className="contact-info-icon">
                    <i className={info.icon}></i>
                  </div>
                  <div className="contact-info-content">
                    <h4>{info.title}</h4>
                    {info.contacts ? (
                      <div className="email-list">
                        {info.contacts.map((contact, idx) => (
                          <a 
                            key={idx} 
                            href={`mailto:${contact.email}`}
                            className="email-link"
                          >
                            <strong>{contact.name}:</strong> {contact.email}
                          </a>
                        ))}
                      </div>
                    ) : (
                      <>
                        <p className="contact-info-main">{info.content}</p>
                        {info.subtext && (
                          <p className="contact-info-sub">{info.subtext}</p>
                        )}
                      </>
                    )}
                  </div>
                </div>
              ))}
              
              {/* Botón de WhatsApp */}
              <div className="whatsapp-contact">
                <div className="whatsapp-icon">
                  <i className="fab fa-whatsapp"></i>
                </div>
                <div>
                  <h4>WhatsApp Directo</h4>
                  <p>Respuesta inmediata para consultas urgentes</p>
                  <a 
                    href="https://wa.me/5493544639290?text=Hola%20OLPEAL,%20me%20interesan%20sus%20productos%20de%20olivos,%20pecanes%20y%20almendros" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="whatsapp-btn"
                  >
                    <i className="fab fa-whatsapp me-2"></i>
                    Enviar mensaje por WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Columna de ubicaciones */}
          <div className="locations-column">
            <div className="locations-card">
              <h3 className="contact-card-title">
                <i className="fas fa-map-marker-alt me-2"></i>
                Nuestras Ubicaciones
              </h3>
              
              {/* Selector de ubicación */}
              <div className="location-selector">
                {locations.map(location => (
                  <button
                    key={location.id}
                    className={`location-tab ${activeMap === location.id ? 'active' : ''}`}
                    onClick={() => setActiveMap(location.id)}
                  >
                    <i className="fas fa-tractor me-2"></i>
                    {location.name}
                  </button>
                ))}
              </div>
              
              {/* Información de la ubicación activa */}
              {locations.map(location => (
                <div 
                  key={location.id} 
                  className={`location-details ${activeMap === location.id ? 'active' : ''}`}
                >
                  <div className="location-info">
                    <h4 className="location-name">{location.name}</h4>
                    <p className="location-address">
                      <i className="fas fa-map-pin me-2"></i>
                      {location.address}
                    </p>
                    <p className="location-description">{location.description}</p>
                    
                    <div className="location-coordinates">
                      <span>Coordenadas:</span>
                      <code>{location.coordinates}</code>
                    </div>
                    
                    <a 
                      href={location.mapUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="map-link-btn"
                    >
                      <i className="fas fa-external-link-alt me-2"></i>
                      Ver en Google Maps
                    </a>
                  </div>
                  
                  {/* Mapa de ubicación (placeholder con imagen) */}
                  <div className="location-map">
                    <div className="map-placeholder">
                      <i className="fas fa-map-marked-alt"></i>
                      <p>Ubicación en Córdoba, Argentina</p>
                      <div className="map-coordinates">
                        <span>{location.coordinates}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              
              {/* Información adicional */}
              <div className="location-extra">
                <div className="extra-info">
                  <i className="fas fa-info-circle"></i>
                  <p>Ambos campos se encuentran en la provincia de Córdoba, Argentina, zona ideal para el cultivo de olivos, pecanes y almendros.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;